export default __webpack_public_path__ + "static/media/Img-01.4f0ca283.jpg";